import { useEffect, useState } from 'react';
import { Table, Select, Input, Pagination, Modal, message } from 'antd';
import { useDispatch, useSelector } from 'react-redux';
import { fetchPasswordHistoryAsync } from '../../redux/slice/auth/authSlice';

function PasswordHistory() {
    const dispatch = useDispatch();
    const { userdata, isAuthenticated, passwordHistory } = useSelector((state) => state.authSlice);
    let locale = {
        emptyText: 'No data!',
    };

    const columns = [
        {
            title: 'User Name',
            dataIndex: 'date-time',
            // sorter: true,
            render: (_, record) => (
                <span className=''>{record.username}</span>

            )
        },
        {
            title: 'Remark',
            dataIndex: 'date-time',
            // sorter: true,
            render: (_, record) => (
                <span className=''>{record.remark}</span>

            )
        },
        {
            title: 'Date',
            dataIndex: 'date-time',
            // sorter: true,
            render: (_, record) => (
                <span className=''>{new Date(record.createdAt).toLocaleString()}</span>

            )
        },

    ];

    const [filteredData, setFilteredData] = useState();
    const [userArray, setUserArray] = useState([])
    const [submitClick, setSubmitClick] = useState(false)
    const [current, setCurrent] = useState(1);
    const [pageSize, setPageSize] = useState(10);
    const [password, setPassword] = useState('')

    useEffect(() => {
        dispatch(fetchPasswordHistoryAsync());
    }, [dispatch]);

    const handleSearch = (value, dataIndex) => {
        if (!value) {
            setFilteredData([]);
            return;
        }

        const searchTermLower = value.toLowerCase();
        const filtered = passwordHistory?.data.filter(item =>
            ['username', 'remark',]
                .some(key =>
                    item[key] &&
                    item[key].toString().toLowerCase().includes(searchTermLower)
                )
        );

        setFilteredData(filtered);
    };


    const handlePageSizeChange = (e) => {
        setPageSize(e);
        setCurrent(1);
    };

    const handleFirst = () => setCurrent(1);
    const handleLast = () => setCurrent(Math.ceil(filteredData?.length / pageSize));


    const startIndex = (current - 1) * pageSize;
    const endIndex = startIndex + pageSize;
    // const paginatedData = filteredData?.length > 0
    //     ? filteredData.slice(startIndex, endIndex)
    //     : passwordHistory?.data?.slice(startIndex, endIndex) || [];

    const paginatedData = filteredData?.slice(startIndex, endIndex);

    useEffect(() => {
        if (passwordHistory) {
            setFilteredData(passwordHistory?.data)
        }
    }, passwordHistory)
    return (
        <div className='relative min-w-full'>
            <div className='grid grid-cols-12 relative    p-[15px] lg:px-[30px]' >
                <div className='col-span-12 '>
                    <div className='pt-[5px] px-[6px] pb-[6px] font-bold text-[14px] !bg-[linear-gradient(#022c43,_#18b0c8)] mb-0 border-b-[1px_solid_#0000002d] !text-[#ffffff] [word-wrap:break-word]'>
                        <span className='relative top-px font-bold text-[0.875rem] !text-[#ffffff]'>Password Change History</span>
                    </div>
                    <div className='bg-[#fff] border rounded-[.375rem]'>
                        <div className='p-[1.25rem] flex-auto '>
                            <Table
                                title={() => (
                                    <div className='grid grid-cols-12 mb-[20px]'>
                                        <div className='col-span-12 lg:col-span-6 flex items-center justify-center lg:justify-start mb-[.9rem] lg:mb-[0px]'>
                                            <div className='text-[#333]'>
                                                <label>
                                                    Show
                                                    <Select defaultValue={10} onChange={handlePageSizeChange} className='pagesize-select mx-[5px]'>
                                                        <Select.Option value={10}>10</Select.Option>
                                                        <Select.Option value={25}>25</Select.Option>
                                                        <Select.Option value={50}>50</Select.Option>
                                                        <Select.Option value={100}>100</Select.Option>
                                                    </Select>
                                                    entries
                                                </label>
                                            </div>
                                        </div>
                                        <div className='col-span-12 lg:col-span-6 flex items-center justify-center lg:justify-end'>
                                            <div className='text-[#333]'>
                                                <label>
                                                    Search:
                                                    <Input
                                                        onChange={e => handleSearch(e.target.value, ['name', 'user_name'])}
                                                        style={{ width: '150px', marginLeft: '5px' }}
                                                    />
                                                </label>
                                            </div>
                                        </div>
                                    </div>
                                )}
                                locale={locale}
                                columns={columns}
                                className='downline-list'
                                bordered
                                dataSource={paginatedData}
                                pagination={false}
                            />
                            <div className='grid grid-cols-12 items-center pt-[1.5rem] lg:pt-[.75rem] text-[#333]'>
                                <div className='col-span-12 lg:col-span-6 text-[#333] text-[0.813rem]'>
                                    Showing {startIndex + 1} - {endIndex} of {filteredData && filteredData.length} entries
                                </div>
                                <div className='col-span-12 lg:col-span-6 flex items-center justify-end  pt-[1rem] lg:pt-[0px] lg:mt-[0rem]'>
                                    <button className='text-[0.813rem]  text-[#666] border-[1px]  border-[transparent] bg-transparent [box-shadow:none] box-border inline-block min-w-[1.5em] px-[1em] py-[.5em] ml-[2px] text-center no-underline rounded-[2px] cursor-pointer' type='button' onClick={handleFirst} style={{ marginRight: 8 }}>First</button>
                                    <Pagination
                                        current={current}
                                        pageSize={pageSize}
                                        total={filteredData && filteredData.length}
                                        onChange={(page) => setCurrent(page)}
                                        itemRender={(page, type, originalElement) => {
                                            if (type === 'prev') {
                                                return <button type='button' className='!cursor-pointer'>Previous</button>;
                                            }
                                            if (type === 'page') {
                                                return null;
                                            }
                                            if (type === 'next') {
                                                return <button type='button' className='!cursor-pointer'>Next</button>;
                                            }
                                            return originalElement;
                                        }}
                                        showSizeChanger={false}
                                    />
                                    <button className='text-[0.813rem]  text-[#666] border-[1px] border-[transparent] bg-transparent [box-shadow:none] box-border inline-block min-w-[1.5em] px-[1em] py-[.5em] ml-[2px] text-center no-underline rounded-[2px]  cursor-pointer' type='button' onClick={handleLast} style={{ marginLeft: 8 }}>Last</button>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    )
}


export default PasswordHistory;
